import { useState, useEffect } from "react";

export function useDarkMode() {
  // Initialize with false to avoid hydration mismatch, then check in useEffect
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Set initial dark mode state
    setIsDark(document.documentElement.classList.contains("dark"));

    const checkDarkMode = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    // Watch for theme changes
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return { isDark };
}
